var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetToKnowUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 304,
    height: 313,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    stroke: "#FFF",
    d: "M303 159.52C303 243.747 244.49 312 157.87 312 71.226 312 1 243.726 1 159.52c0-42.14 9.054-81.777 28.925-110.87C49.79 19.564 80.471 1 123.776 1 210.458 1 303 62.883 303 159.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A1D57",
    d: "m147.868 118.939 29.708 22.453a5 5 0 0 1 0 7.978l-29.708 22.453a5 5 0 0 1-8.014-3.989v-44.907a5 5 0 0 1 8.014-3.988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetToKnowUs);
export default __webpack_public_path__ + "static/media/get-to-know-us.f91e8fefd623f30a72f09c14496e1cce.svg";
export { ForwardRef as ReactComponent };